module.exports = __webpack_public_path__ + "img/guernsey.42432190.svg";